import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import AwardRegularIcon from '../../shared/icons/award-regular-icon';
import PiggyBankRegularIcon from '../../shared/icons/piggy-bank-regular-icon';

import { useAemContent } from '../../shared/hooks/hooks';

import { formatNaDisplayValue } from '../../shared/utils/format/format';

import { ProductData } from '../../shared/types/graphql-types';
import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../shared/constants/cms';

import './tire-life-warranty-info.scss';

interface TireLifeWarrantyInfoProps {
  milesPerDollar?: number;
  product?: ProductData;
  showTooltip?: boolean;
  warranty?: number;
}

function TireLifeWarrantyInfo(props: TireLifeWarrantyInfoProps) {
  const {
    milesPerDollar: milesPerDollarProp,
    product,
    showTooltip = false,
    warranty: warrantyProp
  } = props;
  const { milesPerDollar = milesPerDollarProp } =
    product?.recommendationData || {};
  const { mileage } = product?.recommendationData || product?.tdsData || {};
  const { median = 0, warranty = warrantyProp } = mileage || {};
  const actualPrice = product?.mapPrice?.value ?? product?.price?.value;
  const actualMilesPerDollar =
    milesPerDollar ?? Math.round(median / (actualPrice || 1));

  const { aemTooltipsContent } = useAemContent(
    AEM_CONTENT_PAGE_IDS.treadwellPdp
  );
  const milesPerDollarContent =
    aemTooltipsContent?.[AEM_CONTENT_IDS.milesPerDollar];

  return (
    <div styleName="range-top-container">
      <div styleName="item-container">
        <div styleName="title">
          <AwardRegularIcon styleName="icon" />
          <Typography weight="bold">Tire Warranty</Typography>
        </div>
        <Typography styleName="metric">
          {formatNaDisplayValue(warranty || product?.mileageWarranty, true)}
        </Typography>
      </div>
      <div styleName="item-container">
        <div styleName="title">
          <PiggyBankRegularIcon styleName="icon" />
          <Typography weight="bold">
            {milesPerDollarContent?.title || 'Miles per Dollar'}
          </Typography>
          {showTooltip && (
            <Tooltip
              content={milesPerDollarContent?.tipText}
              styleName="tooltip"
            />
          )}
        </div>
        <Typography styleName="metric">
          {formatNaDisplayValue(actualMilesPerDollar)}
        </Typography>
      </div>
    </div>
  );
}

export default TireLifeWarrantyInfo;
